// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { ValidationVocabularyMetaSchemaType } from "./ValidationVocabularyMetaSchemaType";
import {
  ValidationVocabularyMetaSchemaTypeFromJSON,
  ValidationVocabularyMetaSchemaTypeFromJSONTyped,
  ValidationVocabularyMetaSchemaTypeToJSON,
  ValidationVocabularyMetaSchemaTypeToJSONTyped,
} from "./ValidationVocabularyMetaSchemaType";

/**
 *
 * @export
 * @interface ProcessReadInputSchema
 */
export interface ProcessReadInputSchema {
  /**
   *
   */
  $id?: string;
  /**
   *
   */
  $schema?: string;
  /**
   *
   */
  $ref?: string;
  /**
   *
   */
  $anchor?: string;
  /**
   *
   */
  $dynamicRef?: string;
  /**
   *
   */
  $dynamicAnchor?: string;
  /**
   *
   */
  $vocabulary?: { [key: string]: boolean };
  /**
   *
   */
  $comment?: string;
  /**
   *
   */
  $defs?: { [key: string]: any | null };
  /**
   *
   */
  prefixItems?: Array<any>;
  /**
   *
   */
  items?: any | null;
  /**
   *
   */
  contains?: any | null;
  /**
   *
   */
  additionalProperties?: any | null;
  /**
   *
   */
  properties?: { [key: string]: any | null };
  /**
   *
   */
  patternProperties?: { [key: string]: any | null };
  /**
   *
   */
  dependentSchemas?: { [key: string]: any | null };
  /**
   *
   */
  propertyNames?: any | null;
  /**
   *
   */
  _if?: any | null;
  /**
   *
   */
  then?: any | null;
  /**
   *
   */
  _else?: any | null;
  /**
   *
   */
  allOf?: Array<any>;
  /**
   *
   */
  anyOf?: Array<any>;
  /**
   *
   */
  oneOf?: Array<any>;
  /**
   *
   */
  not?: any | null;
  /**
   *
   */
  unevaluatedItems?: any | null;
  /**
   *
   */
  unevaluatedProperties?: any | null;
  /**
   *
   */
  type?: ValidationVocabularyMetaSchemaType;
  /**
   *
   */
  _const?: any | null;
  /**
   *
   */
  _enum?: Array<any>;
  /**
   *
   */
  multipleOf?: number;
  /**
   *
   */
  maximum?: number;
  /**
   *
   */
  exclusiveMaximum?: number;
  /**
   *
   */
  minimum?: number;
  /**
   *
   */
  exclusiveMinimum?: number;
  /**
   *
   */
  maxLength?: number;
  /**
   *
   */
  minLength?: number;
  /**
   *
   */
  pattern?: string;
  /**
   *
   */
  maxItems?: number;
  /**
   *
   */
  minItems?: number;
  /**
   *
   */
  uniqueItems?: boolean;
  /**
   *
   */
  maxContains?: number;
  /**
   *
   */
  minContains?: number;
  /**
   *
   */
  maxProperties?: number;
  /**
   *
   */
  minProperties?: number;
  /**
   *
   */
  required?: Set<string>;
  /**
   *
   */
  dependentRequired?: { [key: string]: Set<string> };
  /**
   *
   */
  title?: string;
  /**
   *
   */
  description?: string;
  /**
   *
   */
  _default?: any | null;
  /**
   *
   */
  deprecated?: boolean;
  /**
   *
   */
  readOnly?: boolean;
  /**
   *
   */
  writeOnly?: boolean;
  /**
   *
   */
  examples?: Array<any>;
  /**
   *
   */
  format?: string;
  /**
   *
   */
  contentEncoding?: string;
  /**
   *
   */
  contentMediaType?: string;
  /**
   *
   */
  contentSchema?: any | null;
  /**
   *
   * @deprecated
   */
  definitions?: { [key: string]: any | null };
  /**
   *
   * @deprecated
   */
  dependencies?: { [key: string]: Set<string> | null };
  /**
   *
   * @deprecated
   */
  $recursiveAnchor?: string;
  /**
   *
   * @deprecated
   */
  $recursiveRef?: string;
}

/**
 * Check if a given object implements the ProcessReadInputSchema interface.
 */
export function instanceOfProcessReadInputSchema(value: object): value is ProcessReadInputSchema {
  return true;
}

export function ProcessReadInputSchemaFromJSON(json: any): ProcessReadInputSchema {
  return ProcessReadInputSchemaFromJSONTyped(json, false);
}

export function ProcessReadInputSchemaFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ProcessReadInputSchema {
  if (json == null) {
    return json;
  }
  return {
    $id: json["$id"] == null ? undefined : json["$id"],
    $schema: json["$schema"] == null ? undefined : json["$schema"],
    $ref: json["$ref"] == null ? undefined : json["$ref"],
    $anchor: json["$anchor"] == null ? undefined : json["$anchor"],
    $dynamicRef: json["$dynamicRef"] == null ? undefined : json["$dynamicRef"],
    $dynamicAnchor: json["$dynamicAnchor"] == null ? undefined : json["$dynamicAnchor"],
    $vocabulary: json["$vocabulary"] == null ? undefined : json["$vocabulary"],
    $comment: json["$comment"] == null ? undefined : json["$comment"],
    $defs: json["$defs"] == null ? undefined : json["$defs"],
    prefixItems: json["prefixItems"] == null ? undefined : json["prefixItems"],
    items: json["items"] === undefined ? undefined : json["items"] === null ? null : json["items"],
    contains:
      json["contains"] === undefined
        ? undefined
        : json["contains"] === null
        ? null
        : json["contains"],
    additionalProperties:
      json["additionalProperties"] === undefined
        ? undefined
        : json["additionalProperties"] === null
        ? null
        : json["additionalProperties"],
    properties: json["properties"] == null ? undefined : json["properties"],
    patternProperties: json["patternProperties"] == null ? undefined : json["patternProperties"],
    dependentSchemas: json["dependentSchemas"] == null ? undefined : json["dependentSchemas"],
    propertyNames:
      json["propertyNames"] === undefined
        ? undefined
        : json["propertyNames"] === null
        ? null
        : json["propertyNames"],
    _if: json["if"] === undefined ? undefined : json["if"] === null ? null : json["if"],
    then: json["then"] === undefined ? undefined : json["then"] === null ? null : json["then"],
    _else: json["else"] === undefined ? undefined : json["else"] === null ? null : json["else"],
    allOf: json["allOf"] == null ? undefined : json["allOf"],
    anyOf: json["anyOf"] == null ? undefined : json["anyOf"],
    oneOf: json["oneOf"] == null ? undefined : json["oneOf"],
    not: json["not"] === undefined ? undefined : json["not"] === null ? null : json["not"],
    unevaluatedItems:
      json["unevaluatedItems"] === undefined
        ? undefined
        : json["unevaluatedItems"] === null
        ? null
        : json["unevaluatedItems"],
    unevaluatedProperties:
      json["unevaluatedProperties"] === undefined
        ? undefined
        : json["unevaluatedProperties"] === null
        ? null
        : json["unevaluatedProperties"],
    type:
      json["type"] == null ? undefined : ValidationVocabularyMetaSchemaTypeFromJSON(json["type"]),
    _const: json["const"] === undefined ? undefined : json["const"] === null ? null : json["const"],
    _enum: json["enum"] == null ? undefined : json["enum"],
    multipleOf: json["multipleOf"] == null ? undefined : json["multipleOf"],
    maximum: json["maximum"] == null ? undefined : json["maximum"],
    exclusiveMaximum: json["exclusiveMaximum"] == null ? undefined : json["exclusiveMaximum"],
    minimum: json["minimum"] == null ? undefined : json["minimum"],
    exclusiveMinimum: json["exclusiveMinimum"] == null ? undefined : json["exclusiveMinimum"],
    maxLength: json["maxLength"] == null ? undefined : json["maxLength"],
    minLength: json["minLength"] == null ? undefined : json["minLength"],
    pattern: json["pattern"] == null ? undefined : json["pattern"],
    maxItems: json["maxItems"] == null ? undefined : json["maxItems"],
    minItems: json["minItems"] == null ? undefined : json["minItems"],
    uniqueItems: json["uniqueItems"] == null ? undefined : json["uniqueItems"],
    maxContains: json["maxContains"] == null ? undefined : json["maxContains"],
    minContains: json["minContains"] == null ? undefined : json["minContains"],
    maxProperties: json["maxProperties"] == null ? undefined : json["maxProperties"],
    minProperties: json["minProperties"] == null ? undefined : json["minProperties"],
    required: json["required"] == null ? undefined : new Set(json["required"]),
    dependentRequired: json["dependentRequired"] == null ? undefined : json["dependentRequired"],
    title: json["title"] == null ? undefined : json["title"],
    description: json["description"] == null ? undefined : json["description"],
    _default:
      json["default"] === undefined ? undefined : json["default"] === null ? null : json["default"],
    deprecated: json["deprecated"] == null ? undefined : json["deprecated"],
    readOnly: json["readOnly"] == null ? undefined : json["readOnly"],
    writeOnly: json["writeOnly"] == null ? undefined : json["writeOnly"],
    examples: json["examples"] == null ? undefined : json["examples"],
    format: json["format"] == null ? undefined : json["format"],
    contentEncoding: json["contentEncoding"] == null ? undefined : json["contentEncoding"],
    contentMediaType: json["contentMediaType"] == null ? undefined : json["contentMediaType"],
    contentSchema:
      json["contentSchema"] === undefined
        ? undefined
        : json["contentSchema"] === null
        ? null
        : json["contentSchema"],
    definitions: json["definitions"] == null ? undefined : json["definitions"],
    dependencies: json["dependencies"] == null ? undefined : json["dependencies"],
    $recursiveAnchor: json["$recursiveAnchor"] == null ? undefined : json["$recursiveAnchor"],
    $recursiveRef: json["$recursiveRef"] == null ? undefined : json["$recursiveRef"],
  };
}

export function ProcessReadInputSchemaToJSON(json: any): ProcessReadInputSchema {
  return ProcessReadInputSchemaToJSONTyped(json, false);
}

export function ProcessReadInputSchemaToJSONTyped(
  value?: ProcessReadInputSchema | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    $id: value["$id"],
    $schema: value["$schema"],
    $ref: value["$ref"],
    $anchor: value["$anchor"],
    $dynamicRef: value["$dynamicRef"],
    $dynamicAnchor: value["$dynamicAnchor"],
    $vocabulary: value["$vocabulary"],
    $comment: value["$comment"],
    $defs: value["$defs"],
    prefixItems: value["prefixItems"],
    items: value["items"],
    contains: value["contains"],
    additionalProperties: value["additionalProperties"],
    properties: value["properties"],
    patternProperties: value["patternProperties"],
    dependentSchemas: value["dependentSchemas"],
    propertyNames: value["propertyNames"],
    if: value["_if"],
    then: value["then"],
    else: value["_else"],
    allOf: value["allOf"],
    anyOf: value["anyOf"],
    oneOf: value["oneOf"],
    not: value["not"],
    unevaluatedItems: value["unevaluatedItems"],
    unevaluatedProperties: value["unevaluatedProperties"],
    type: ValidationVocabularyMetaSchemaTypeToJSON(value["type"]),
    const: value["_const"],
    enum: value["_enum"],
    multipleOf: value["multipleOf"],
    maximum: value["maximum"],
    exclusiveMaximum: value["exclusiveMaximum"],
    minimum: value["minimum"],
    exclusiveMinimum: value["exclusiveMinimum"],
    maxLength: value["maxLength"],
    minLength: value["minLength"],
    pattern: value["pattern"],
    maxItems: value["maxItems"],
    minItems: value["minItems"],
    uniqueItems: value["uniqueItems"],
    maxContains: value["maxContains"],
    minContains: value["minContains"],
    maxProperties: value["maxProperties"],
    minProperties: value["minProperties"],
    required: value["required"] == null ? undefined : Array.from(value["required"] as Set<any>),
    dependentRequired: value["dependentRequired"],
    title: value["title"],
    description: value["description"],
    default: value["_default"],
    deprecated: value["deprecated"],
    readOnly: value["readOnly"],
    writeOnly: value["writeOnly"],
    examples: value["examples"],
    format: value["format"],
    contentEncoding: value["contentEncoding"],
    contentMediaType: value["contentMediaType"],
    contentSchema: value["contentSchema"],
    definitions: value["definitions"],
    dependencies: value["dependencies"],
    $recursiveAnchor: value["$recursiveAnchor"],
    $recursiveRef: value["$recursiveRef"],
  };
}
